module.exports = __webpack_public_path__ + "static/media/img-thumbnail-virtualhorseracing@2x.c3c63c70.png";